import { getFormattedDurationFromRange } from '@/shared/lib/utils/date-time';
import dayjs, { type Dayjs } from 'dayjs';
import { useTranslation } from 'react-i18next';

export const Duration = ({ date }: { date: Dayjs }) => {
  const { t } = useTranslation();

  return (
    <span data-testid='duration'>
      {getFormattedDurationFromRange(
        date.toISOString(),
        dayjs().toISOString(),
        t,
      )}
    </span>
  );
};